var map = {
	"./activity-icon.svg": 46618,
	"./bg_requestform.svg": 66138,
	"./chat-icon.svg": 23561,
	"./diagnostic-icon.svg": 81248,
	"./forms-datapoint-icon.svg": 22985,
	"./inbox-icon.svg": 66537,
	"./job-scheduling-icon.svg": 16479,
	"./new-app-icon.svg": 20629,
	"./overview-icon-test.svg": 1725,
	"./overview-icon.svg": 24916,
	"./task-icon.svg": 23274,
	"./user-icon.svg": 2028,
	"./wp-dashboard-icon.svg": 68705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54614;